<template>
    <div id="pagination">
        <div class="actions">
            <a @click="decrease"><</a>
            <input v-model="currentPage" :max="Math.ceil(total / selectedPage)" :min="1" trim type="number" />
            <div id="seperator">/</div>
            <span style="width: auto; margin-left: 6px">{{ Math.ceil(total / selectedPage) }}</span>
            <a @click="increase">></a>
        </div>
        <div class="page">
            <select v-model="selectedPage">
                <option v-for="(size, i) in pageSizes" :key="i" :value="parseInt(size)">
                    {{ size + $t("message.perPage") }}
                </option>
            </select>
        </div>
    </div>
</template>

<script>
import { getPersistenceData, setPersistenceData } from "../utils/persistenceStorage";

export default {
    name: "Pagination",
    props: {
        total: {
            type: Number,
            require: true,
        },
        pageSizes: {
            type: Array,
        },
        pageChange: {
            type: Function,
        },
        pageSizeLocalStorageKey: {
            type: String,
        },
        defaultCurrentPage: {
            type: Number,
        },
        defaultPageSize: {
            type: Number,
        },
    },
    data() {
        const calculatedPS = !isNaN(getPersistenceData(this.pageSizeLocalStorageKey) || "undefined")
            ? parseInt(getPersistenceData(this.pageSizeLocalStorageKey))
            : parseInt(this.pageSizes[0]);

        return {
            currentPage: this.defaultCurrentPage || 1,
            selectedPage: this.defaultPageSize || calculatedPS,
        };
    },
    methods: {
        decrease() {
            if (this.currentPage > 1) this.currentPage--;
        },
        increase() {
            if (this.currentPage < Math.ceil(this.total / this.selectedPage)) this.currentPage++;
        },
    },
    mounted() {
        this.pageChange(this.currentPage, this.selectedPage);
    },
    watch: {
        total(newVal) {
            if (this.currentPage > newVal) this.currentPage = 1;
        },
        selectedPage(newVal) {
            this.currentPage = 1;
            this.pageChange(this.currentPage, this.selectedPage);
            if (this.pageSizeLocalStorageKey) setPersistenceData(this.pageSizeLocalStorageKey, newVal);
        },
        currentPage(newVal) {
            this.pageChange(this.currentPage, this.selectedPage);
        },
    },
};
</script>
<style lang="scss" scoped>
#pagination {
    display: flex;
    align-items: center;

    .actions {
        user-select: none;
        display: flex;
        align-items: center;
    }

    select {
        margin-left: 6px;
        height: 30px;
        border: none;
        border-radius: 6px;
        padding: 4px;
    }

    span {
        height: 30px;
        width: 30px !important;
        border: none;
        background-color: #ffffff;
        border-radius: 6px;
        padding: 4px;
        display: block;
        text-align: center;
        align-items: center;
        font-family: Poppins;
        font-size: 12px;
        color: #181c32;
    }

    #seperator {
        padding: 2px;
        font-size: 15px;
    }

    input {
        height: 30px;
        width: 40px;
        border: none;
        background-color: #ffffff;
        border-radius: 6px;
        padding: 4px;
        display: flex;
        text-align: center;
        align-items: center;
        font-family: Poppins;
        font-size: 12px;
        color: #181c32;
        margin-right: 6px;
    }

    input:invalid {
        box-shadow: none;
    }

    a {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30px;
        height: 30px;
        border-radius: 6px;
        background-color: #ffffff;
        font-family: Poppins;
        font-size: 18px;
        margin-left: 6px;

        &:first-child {
            margin-left: 0;
            margin-right: 6px;
        }
    }
}

.dark-mode {
    #seperator {
        color: white;
    }
}
</style>
